<ng-container>
	<base-display [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()" [showScale]="showScale()" [scaleType]="scaleType()"></base-display>
</ng-container>